import React from 'react';
import VideoSlide from '../../body/VideoSlide';

const FollowingThrough = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoSlide vidSrc={1194418646}></VideoSlide>
    </div>
  );
};

export default FollowingThrough;
